export default __webpack_public_path__ + "static/media/ep_08.05e37a5f.png";